import React, {useState, useEffect } from 'react';
import {
    Grid,
} from '@mui/material';
import { useHistory } from "react-router-dom";
import dayjs from 'dayjs';

const Verification = (data) => {
    const INACTIVE_EVENT_MESSAGE = 'The previously selected event is no longer active. Please select another active event.';
    const { count, isFullMatch } = data.location.state.data;
    const { phoneNumber, firstName, lastName, adjusterId, email, checkedIn, tempEventId, workEmail, noSearchFound } = data.location.state.data?.users?.$values[0] ?? data.location.state.data ?? {};
    console.log("data", data.location.state.data);
    console.log("noSearchFound", noSearchFound)
    const history = useHistory();
    // ** States   
    const [hasResult, setHasResult] = useState(true);
    const [eventName, setEventName] = useState(localStorage.getItem('defaultEventName') ?? '');
    const [error, setError] = useState(null);
    const [openProgressBar, setOpenProgressBar] = useState(false);

    // get the event that is currently running from API. 
    // after that, store it in local storage
    // we need its name to display to the user 
    useEffect(() => {
        const defaultEventId = localStorage.getItem('defaultEventId');
        if (defaultEventId) {
            fetch(`/api/Event/GetEventById?id=${defaultEventId}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
                    'Content-Type': 'application/json'
                }
            })
                .then(res => res.json())
                .then(data => {
                    // event name is cached so it loads faster
                    const name = data?.events?.$values[0]?.eventName;
                    if (name) {
                        setEventName(name);
                        localStorage.setItem('defaultEventName', name);
                    }
                })
                .catch(() => {});
        }
    }, []);

    const redirectToNoEventIfInactive = async () => {
        const defaultEventId = localStorage.getItem('defaultEventId');
        if (!defaultEventId || defaultEventId.trim() === "") {
            localStorage.setItem('eventInactiveMessage', INACTIVE_EVENT_MESSAGE);
            history.push('/NoEvent');
            return true;
        }

        try {
            const response = await fetch(`/api/Event/GetEventById?id=${defaultEventId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            const eventEndDate = data?.events?.$values?.[0]?.eventEndDate;

            if (!eventEndDate || dayjs(eventEndDate).isBefore(dayjs().startOf('day'))) {
                localStorage.setItem('defaultEventId', "");
                localStorage.setItem('eventInactiveMessage', INACTIVE_EVENT_MESSAGE);
                history.push('/NoEvent');
                return true;
            }
        } catch (ex) {
            localStorage.setItem('eventInactiveMessage', INACTIVE_EVENT_MESSAGE);
            history.push('/NoEvent');
            return true;
        }

        return false;
    };

    const handleYes = async () => {
        if (await redirectToNoEventIfInactive()) {
            return;
        }

        if (count === 0) {
            let params =
            {
                firstName: firstName,
                lastName: lastName,
                phoneNumber: phoneNumber,
                email: email
            }
            handleAddUser(params);
        }
        history.push({ pathname: '/EventVerification', state: { data: data.history.location.state?.data } });
    }

    const handleAddUser = async (params) => {
        if (await redirectToNoEventIfInactive()) {
            return;
        }

        setOpenProgressBar(true);
        setError(null);

        fetch(`/api/Adjuster/PostNewTempUser`, {
            method: 'POST',
            body: JSON.stringify({
                "FirstName": params.firstName,
                "LastName": params.lastName,
                "PhoneNumber": params.phoneNumber,
                "Email": params.email,
            }),
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then((data) => {
                if (JSON.stringify(data).length > 0) {
                    setHasResult(true);
                    history.push({ pathname: '/EventVerification', state: { data: data } });
                }
                else {
                    setError("No results found");
                }
                setOpenProgressBar(false);
            })
            .catch((error) => {
                if (error.message.includes("No user")) {
                    setError("No user found with adjuster Id: " + params.pilotId);
                }
                else if (error.message.includes("Unauthorized")) {
                    history.push('/noevent');
                }
                else {
                    setError("An error occurred, please try again later");
                }
                setOpenProgressBar(false);
            });
    }

    const handleCreateNewUser = async () => {
        if (await redirectToNoEventIfInactive()) {
            return;
        }

        history.push({ pathname: '/AdjusterInfoEntry', state: { data: { noSearchFound: "No user found with phone number: " + phoneNumber , phoneNumber: phoneNumber }}});
    }

    const handleNo = async () => {
        if (await redirectToNoEventIfInactive()) {
            return;
        }

        history.push(`/Search`);
    }

    useEffect(() => {
        const initializeVerificationPage = async () => {
            await redirectToNoEventIfInactive();
        };

        initializeVerificationPage();
    }, [history]);

    const obfuscateEmail = (email) => {
        if (!email) return '';
        const [name, domain] = email?.split('@');
        const obfuscatedName = name[0] + '***' + name?.slice(-1);
        const obfuscatedDomain = domain[0] + '***' + domain?.slice(-5);
        return `${obfuscatedName}@${obfuscatedDomain}`;
    };

    const obfuscatePhone = (phoneNumber) => {
        return `${phoneNumber?.substring(0, 3)}-***-**${phoneNumber?.slice(-2)}`;
    }

    const FormatPhone = (phoneNumber) => {
        return `${phoneNumber?.substring(0, 3)}-${phoneNumber?.substring(3, 6)}-${phoneNumber?.substring(6, 10)}`;
    }

    return (
        <Grid container spacing={3} justifyContent="center">
            <Grid item xs={11}>
                <div className="text-center space-y-6 w-full mx-auto max-w-screen-lg">
                    <div className="bg-white rounded-lg p-8 space-y-4 flex flex-col shadow-2xl">
                        {noSearchFound ?
                            <>
                                <div className="text-xl text-red-600 font-bold">No user record found!</div>
                                <p className='text-4xl text-black-600 font-bold mb-4 p-8 space-y-6'>{FormatPhone(phoneNumber)}</p>
                                <div className="flex items-center justify-center p-15 space-x-4">
                                    <button className="bg-red-900 text-white rounded-full px-7 py-2" onClick={handleCreateNewUser}>
                                        Proceed and Create New User
                                    </button>
                                </div>
                                <div className="flex items-center justify-center p-15 space-x-4">
                                    <button className="bg-black text-white rounded-full px-7 py-2" onClick={handleNo}>
                                    This Is Not Me – Return to Home Screen.
                                    </button>
                                </div>
                            </>
                            :
                            <>
                                <div className='space-y-6'>
                                    <div className="text-center max-w-full mx-auto space-y-4 p-4">

                                        <h1 className="text-2xl font-bold">{eventName || 'Loading...'}</h1>
                                        <h3 className="text-lg font-bold">PLEASE VERIFY DETAILS BELOW</h3>
                                        {count === -1 ?
                                            <div className="text-xl font-bold text-green-500">
                                                Creating user!
                                                <span className="text-black font-bold"> Please verify all details before proceeding.</span>
                                            </div>
                                            :
                                            count === 0 ? (
                                                <>
                                                    <div className='text-xl text-red-600 font-bold'>No user record found!</div>
                                                    <span className="text-black">Please review and verify the information is correct before proceeding by creating a new user.</span>
                                                </>

                                            ) : (
                                                <div className={`text-xl font-bold ${isFullMatch ? 'text-green-500' : 'text-yellow-500'}`}>
                                                    {isFullMatch ?
                                                        <>
                                                            User found!
                                                            <span className="text-black font-bold"> Please verify all details. If your information has changed or been updated, please contact Pilot HR at a later time to have this information updated. If this information was once correct, please continue through the check-in process.</span>
                                                        </>
                                                        :
                                                        <>Possible match found!<span className="text-black font-thin"> Is that you? Please verify all details.</span><span className="text-black font-bold"> If your information has changed or been updated, please contact Pilot HR at a later time to have this information updated. If this information was once correct, please continue through the check-in process.</span>
                                                        </>
                                                    }
                                                </div>
                                            )}

                                    </div>
                                    <div className="flex justify-between items-start space-x-4 ">
                                        <div className="w-1/2">
                                            <div className="flex justify-between items-start space-x-4">
                                                <div className="w-1/2 text-left">
                                                </div>
                                                <div className="w-1/2 text-left">
                                                    <label className="block  font-semibold">First Name:</label>
                                                    <p className='text-xl text-red-600 font-bold mb-4 '>{firstName}</p>
                                                    <label className="block font-semibold">Personal Email:</label>
                                                    <p className='text-xl text-red-600 font-bold mb-4 '>{obfuscateEmail(email)}</p>
                                                    <label className="block font-semibold">Cell Phone:</label>
                                                    <p className='text-xl text-red-600 font-bold mb-4 '>{obfuscatePhone(phoneNumber)}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="w-1/2">
                                            <label className="block  font-semibold">Last Name:</label>
                                            <p className='text-xl text-red-600 font-bold mb-4 '>{lastName}</p>
                                            <label className="block font-semibold">Work Email:</label>
                                            <p className='text-xl text-red-600 font-bold mb-4 '>{obfuscateEmail(workEmail)}</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-center p-15 space-x-4">
                                        <button className="bg-red-900 text-white rounded-full px-7 py-2" onClick={handleYes}>
                                            {count === 0 ? `Proceed to check-in` : `This is me, proceed to check-in`}
                                        </button>
                                    </div>
                                    <div className="flex items-center justify-center p-15 space-x-4">
                                        <button className="bg-black text-white rounded-full px-7 py-2" onClick={handleNo}>
                                            This is not me, go back to home screen.
                                        </button>
                                    </div>
                                </div>
                            </>
                        }
                        <div className="flex justify-center">
                            {error && <div className="text-red-500">{error}</div>}
                        </div>
                    </div>                  
                </div>
            </Grid>
        </Grid>
    );
};

export default Verification;